/* unplugin-vue-components disabled */import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState } from 'vuex';
export default {
  name: 'iHeaderReload',
  emits: ['on-reload'],
  computed: _objectSpread({}, mapState('admin/layout', ['isMobile', 'showSiderCollapse'])),
  methods: {
    handleReload: function handleReload() {
      this.$emit('on-reload');
    }
  }
};